// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Tip+a","separator":"style_separator__i0G0y","inner":"style_inner__lmLHm"};